<style>
  .user-screen-star{
    color: orange;
    text-align: left !important;
  }
</style>

<template>
<div v-show="showLoader" class="loader"><img src="../../../assets/images/loader.gif" alt=""></div> 
    <main class="main_content">
      <div class="row mb-4 align-items-center">
        <div class="col-md-8">
          <h2 class="page_title">Purchase Order Detail </h2>
          <h4 class="page_sub_title">Inquiry ID:{{this.inq_id}} <span>|</span> Quotation ID:{{ this.rfq_id }} <span>|</span> PO ID:{{this.po_id}}</h4>
        </div>
        <div class="col-md-4">
                    <div class="top_btns">
                        <a @click="back_rfqs" class="btn btn-gray me-2">Back</a>
                    </div>
            </div>
      </div>
      <div class="card_box">

        <h3 class="font_700" style="margin-bottom: 15px;">
          Product {{manufacturing_method_count > 1 ? "Details" : "Detail"}}
        </h3>
        <!-- Multiple Product Detail -->
        <div class="accordion detail_view_accordian iquiry-page" id="accordionExample" v-if="manufacturing_method_count > 1">
          <div class="accordion_item" v-for="(manufacturing_method,index) in manufacturing_methods" :key="index" >
            <h2 class="accordion-header" :id="'heading'+index">
              <button :class="index > 0 ? 'accordion-button collapsed': 'accordion-button' " type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index" v-on:click="dataTableUnLoad(index, 0)">
                {{ manufacturing_method.name }}
              </button>
            </h2>
            <div :id="'collapse'+index" :class="index == 0 ? 'accordion-collapse collapse show' : 'accordion-collapse collapse' " :aria-labelledby="'heading'+index" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <!-- Vertiacl Tabs Start Here -->
                <!-- <div class="inquiry_detail detail_content">
                  <div class="row" v-if="products[index].length == 1">
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Manufacturing Method</label>
                        <p>{{ manufacturing_method.name }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Part Number</label>
                        <p>{{ products[index][0].part_number }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Quantity</label>
                        <p>{{  products[index][0].product_quantity }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col">
                      <div class="detail_col">
                        <label>Revision</label>
                        <p>{{  products[index][0].revisions }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 contact_half_col" v-if="products[index][0].upload_product_images != 'N/A' ">
                        <div class="detail_col">
                        <label>Part Drawing</label>
                        <p><span class="material-icons-outlined blue_color">attachment</span> 
                            <a target="_blank" v-for="(prod_images,prod_index) in products[index][0].upload_product_images" :key="prod_index"  :href="prod_images" class="blue_color">Drawing {{ prod_index+1 }} &nbsp;</a>
                        </p>
                        </div>
                    </div>
                    <div class="col-md-3 contact_half_col" v-if="products[index][0].upload_supporting_doc != 'N/A' ">
                        <div class="detail_col">
                        <label>Supporting Documents</label>
                        <p>
                            <span class="material-icons-outlined blue_color">attachment</span>
                            <a target="_blank" v-for="(prod_document,prod_index) in products[index][0].upload_supporting_doc" :key="prod_index" :href="prod_document" class="blue_color">Document {{ prod_index+1 }} &nbsp;</a>
                        </p>
                        </div>
                    </div>
                    <div class="col-md-12" v-if="products[index][0].notes  != 'undefined' ">
                      <div class="detail_col">
                        <label>Message/Notes</label>
                        <p class="font_400">{{ products[index][0].notes }}</p>
                      </div>
                    </div>
                  
                  
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Price Per Quantity</h5>
                        <div class="child_table" v-if="rfqResp.status >= 3 && RFQProductList[index][0].product_price_per_quantiy !== '' " >
                         <table>
                            <thead>
                              <tr>
                                <th>Quantity</th>
                                <th>Price per quantity (USD)</th>
                                <th>Total Cost (USD)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(price, pIndex) in RFQProductList[index][0].per_piece_cost_sell" :key="pIndex">
                                <td v-if="pIndex == 0">{{ 10 }} Piece / Delivery</td>
                                <td v-if="pIndex == 1">{{ 100 }} Piece / Delivery</td>
                                <td v-if="pIndex == 2">{{ 1000 }} Piece / Delivery</td>
                                <td v-if="pIndex == 3">{{ 10000 }} Piece / Delivery</td>
                                <td>
                                  ${{ formatPrice(price) }}
                                </td>
                                <td>
                                  ${{ formatPrice(RFQProductList[index][0].total_sales[pIndex]) }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                  </div>

                  <hr v-if="products[index].length == 1 && rfqResp.status >= 3">
                  <h5 v-if="products[index].length == 1 && rfqResp.status >= 3" class="font_700 my-4">Costs</h5>
                  <div v-if="products[index].length == 1 && rfqResp.status >= 3" class="row">
                      
                      <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][0].tooling_cost != '' ">
                          <div class="detail_col">
                            <label>Non-reoccurring engineering (NRE)</label>
                            <p>
                                ${{ formatPrice(RFQProductList[index][0].nre_cost_sell) }}
                            </p>
                          </div>
                      </div>

                      <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][0].tooling_cost != '' ">
                          <div class="detail_col">
                            <label>Tooling cost (USD)</label>
                            <p>
                                ${{ formatPrice(RFQProductList[index][0].tooling_cost) }}
                            </p>
                          </div>
                      </div>

                      <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][0].additional_cost != '' ">
                          <div class="detail_col">
                            <label>Additional cost (USD)</label>
                            <p>
                                ${{ formatPrice(RFQProductList[index][0].additional_cost) }}
                            </p>
                          </div>
                      </div>
                  </div>
                  <hr v-if="products[index].length == 1 && rfqResp.status >= 3">
                  <h5 v-if="products[index].length == 1 && rfqResp.status >= 3" class="font_700 my-4">Delivery Milestones</h5>
                  <div v-if="products[index].length == 1 && rfqResp.status >= 3" class="row">
                      
                      <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][0].sample_lead_time != '' ">
                          <div class="detail_col">
                            <label>Sample Lead Time (in days)</label>
                            <p>
                                {{ RFQProductList[index][0].sample_lead_time }} 
                            </p>
                          </div>
                      </div>
                      <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][0].production_lead_time != '' ">
                          <div class="detail_col">
                            <label>Production Lead Time (in days)</label>
                            <p>
                                {{ RFQProductList[index][0].production_lead_time }}
                            </p>
                          </div>
                      </div>
                      <div class="col-md-4 contact_half_col" v-if="products[index][0].finish_time != '' ">
                          <div class="detail_col">
                            <label>Delivery Time (in days)</label>
                            <p>
                                {{ RFQProductList[index][0].finish_time }}
                            </p>
                          </div>
                      </div>
                  </div>
                  <h5  v-if="products[index].length == 1 && rfqResp.status >= 3" class="font_700 my-4">Packaging Details</h5>
                  <div class="row" v-if="products[index].length == 1 && rfqResp.status >= 3">
                      <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][0].packaging_type != '' ">
                          <div class="detail_col">
                            <label>Packaging Type</label>
                            <p>
                                {{ RFQProductList[index][0].packaging_type }}
                            </p>
                          </div>
                      </div>
                      <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][0].quantity_per_box != '' ">
                          <div class="detail_col">
                            <label>Quantity per box</label>
                            <p>
                                {{ RFQProductList[index][0].quantity_per_box }}
                            </p>
                          </div>
                      </div>
                      <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][0].package_width != '' ">
                          <div class="detail_col">
                            <label>Size (LxWxH) </label>
                            <p>
                                {{ RFQProductList[index][0].package_length }}x{{ RFQProductList[index][0].package_width }}x{{ RFQProductList[index][0].package_height }} 
                                <span class="info_caption">{{ RFQProductList[index][0].package_size_unit }}</span>
                            </p>
                          </div>
                      </div>
                      <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][0].package_weight != '' ">
                          <div class="detail_col">
                            <label>Weight</label>
                            <p>
                                {{ RFQProductList[index][0].package_weight }}<span class="info_caption">{{ RFQProductList[index][0].package_weight_unit }}</span>
                            </p>
                          </div>
                      </div>
                  </div>
                  
                </div> -->
            <!-- Vertiacl Tabs Start Here -->
                <div class="vertical_tabs" v-if="products[index].length >= 1"  ref="infoBox">
                  <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <button v-for="(product,prod_index) in products[index]" :key="prod_index" :class="prod_index == 0 ? 'active' : '' " :id="'nav-'+ index +'-'+prod_index+'-tab'" data-bs-toggle="tab" :data-bs-target="'#nav-'+ index +'-'+prod_index" type="button" role="tab" :aria-controls="'nav-'+ index +'-'+prod_index" aria-selected="true" v-on:click="dataTableUnLoad( index, prod_index )">Part# {{ product.part_number }}</button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div v-for="(product,prod_index) in products[index]" :key="prod_index" :class="prod_index == 0 ? 'tab-pane fade show active': 'tab-pane fade' " :id="'nav-'+ index +'-'+prod_index" role="tabpanel" :aria-labelledby="'nav-'+ index +'-'+prod_index+'-tab'" >
                      <div class="card_box">
                            <div class="info_tabs">
                              <ul class="nav nav-tabs" id="myTab" role="tablist">

                                  <li class="nav-item" role="presentation">
                                      <button class="active" :id="'dtl-'+product.id+'-01'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-01'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-01'" aria-selected="true">Product Details</button>
                                  </li>
                                  <li class="nav-item" role="presentation">
                                      <button :id="'dtl-'+product.id+'-02'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-02'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-02'" aria-selected="false" v-on:click="dataTableLoad(index, prod_index)">Attachment </button>
                                  </li>
                                  <li class="nav-item" role="presentation">
                                      <button :id="'dtl-'+product.id+'-03'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-03'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-03'" aria-selected="false">Quotation </button>
                                  </li>
                                  <li class="nav-item" role="presentation" v-if="rfqResp.status >= 12 && po_qa_details.length > 0">
                                      <button :id="'dtl-'+product.id+'-04'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-04'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-04'" aria-selected="false">QA </button>
                                  </li>
                              </ul>
                              <div class="tab-content detail_content" id="myTabContent">
                                  <div class="tab-pane fade show active" :id="'detl-'+product.id+'-01'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-01'">
                                    <div class="row">
                                        <div class="col-md-3 contact_half_col">
                                            <div class="detail_col">
                                                <label>Manufacturing Method</label>
                                                <p>{{ manufacturing_method.name }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-3 contact_half_col">
                                            <div class="detail_col">
                                                <label>Part Number</label>
                                                <p>{{ product.part_number }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-3 contact_half_col">
                                            <div class="detail_col">
                                                <label>Quantity</label>
                                                <p>{{product.product_quantity}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-3 contact_half_col">
                                            <div class="detail_col">
                                                <label>Revision</label>
                                                <p>{{product.revisions}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="detail_col">
                                                <label>Message/Notes</label>
                                                <div class="message-notes">
                                                  <p class="font_400">{{product.notes}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                  <div class="tab-pane fade" :id="'detl-'+product.id+'-02'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-02'">
                                    <div class="table_listing">
                                       <table class="display attachment-table" width="100%">
                                          <thead>
                                              <tr>
                                                  <th>Filename.ext</th>
                                                  <th>Part No.</th>
                                                  <th>Document Type</th>
                                                  <th>Date Uploaded</th>
                                                  <th>Uploaded By</th>
                                                  <th>View</th>
                                              </tr>
                                          </thead>
                                      </table>
                                    </div>
                                  </div>
                                  <div class="tab-pane fade" :id="'detl-'+product.id+'-03'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-03'">
                                    <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Price Per Quantity</h5>
                                      <div class="child_table" v-if="rfqResp.status >= 3 && RFQProductList[index][prod_index].product_price_per_quantiy !== '' " >
                                      <table>
                                          <thead>
                                            <tr>
                                              <th>Quantity</th>
                                              <th>Price per quantity (USD)</th>
                                              <th>Total Cost (USD)</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr  v-for="(price, pIndex) in RFQProductList[index][prod_index].per_piece_cost_sell" :key="pIndex">
                                              <td v-if="pIndex == 0">{{ 10 }} Piece / Delivery</td>
                                              <td v-if="pIndex == 1">{{ 100 }} Piece / Delivery</td>
                                              <td v-if="pIndex == 2">{{ 1000 }} Piece / Delivery</td>
                                              <td v-if="pIndex == 3">{{ 10000 }} Piece / Delivery</td>
                                              <td>
                                                ${{ formatPrice(price) }}
                                              </td>
                                              <td>
                                                ${{ formatPrice(RFQProductList[index][prod_index].total_sales[pIndex]) }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Costs</h5>
                                      <div v-if="rfqResp.status >= 3" class="row">
                                          
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].nre_cost_sell != '' ">
                                              <div class="detail_col">
                                                <label>Non-reoccurring engineering.</label>
                                                <p>
                                                    ${{ formatPrice(RFQProductList[index][prod_index].nre_cost_sell) }}
                                                </p>
                                              </div>
                                          </div>
                                        
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].tooling_cost != '' ">
                                              <div class="detail_col">
                                                <label>Tooling cost (USD)</label>
                                                <p>
                                                    ${{ formatPrice(RFQProductList[index][prod_index].tooling_cost) }}
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].additional_cost != '' ">
                                              <div class="detail_col">
                                                <label>Additional cost (USD)</label>
                                                <p>
                                                    ${{ formatPrice(RFQProductList[index][prod_index].additional_cost) }}
                                                </p>
                                              </div>
                                          </div>
                                      </div>
                                      <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Delivery Milestones</h5>
                                      <div v-if="rfqResp.status >= 3" class="row">
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].sample_lead_time != '' ">
                                              <div class="detail_col">
                                                <label>Sample Lead Time (in days)</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].sample_lead_time }} 
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].production_lead_time != '' ">
                                              <div class="detail_col">
                                                <label>Production Lead Time (in days)</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].production_lead_time }}
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-4 contact_half_col" v-if="RFQProductList[index][prod_index].finish_time != '' ">
                                              <div class="detail_col">
                                                <label>Delivery Time (in days)</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].finish_time }}
                                                </p>
                                              </div>
                                          </div>
                                      </div>
                                      <h5  v-if="rfqResp.status >= 3" class="font_700 my-4">Packaging Details</h5>
                                      <div class="row" v-if="rfqResp.status >= 3">
                                          <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][prod_index].packaging_type != '' ">
                                              <div class="detail_col">
                                                <label>Packaging Type</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].packaging_type }}
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][prod_index].quantity_per_box != '' ">
                                              <div class="detail_col">
                                                <label>Quantity per box</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].quantity_per_box }}
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][prod_index].package_width != '' ">
                                              <div class="detail_col">
                                                <label>Size (LxWxH) </label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].package_length }}x{{ RFQProductList[index][prod_index].package_width }}x{{ RFQProductList[index][prod_index].package_height }} 
                                                    <span class="info_caption">{{ RFQProductList[index][prod_index].package_size_unit }}</span>
                                                </p>
                                              </div>
                                          </div>
                                          <div class="col-md-3 contact_half_col" v-if="RFQProductList[index][prod_index].package_weight != '' ">
                                              <div class="detail_col">
                                                <label>Weight</label>
                                                <p>
                                                    {{ RFQProductList[index][prod_index].package_weight }}<span class="info_caption">{{ RFQProductList[index][prod_index].package_weight_unit }}</span>
                                                </p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div v-if="rfqResp.status >= 12 && po_qa_details.length > 0" class="tab-pane fade" :id="'detl-'+product.id+'-04'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-04'">
                                    <template v-for="(po_qa_detail,po_qa_index) in po_qa_details" :key="po_qa_index">
                                      <div class="row" v-if="po_qa_detail.product_id == product.id">
                                        <div class="col-md-4">
                                            <div class="detail_col">
                                                <label>QA Ref No.</label>
                                                <p>{{po_qa_detail.qa_ref_no}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="detail_col">
                                                <label>Passed Items</label>
                                                <p>{{po_qa_detail.qa_pass_qty}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="detail_col">
                                                <label>Rejected Items</label>
                                                <p>{{po_qa_detail.qa_reject_qty}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                              <div class="detail_col">
                                                  <label>QA Remarks</label>
                                                  <p v-html="po_qa_detail.qa_remarks"></p>
                                              </div>
                                          </div>
                                          <div class="col-md-12">
                                              <div class="detail_col">  
                                                <label>Attachment</label>
                                                <p><span class="material-icons-outlined blue_color">attachment</span>                               
                                                    <a target="_blank" :href="po_qa_detail.qa_file" class="blue_color">Attachment&nbsp;</a>
                                                </p>
                            
                                              </div>
                                          </div>
                                      </div>
                                    </template>
                                  </div>
                              </div>
                            </div>
                        </div>
                      
                    </div>
                  </div>
                </div><!-- Vertiacl Tabs Ends Here -->
              </div>
            </div>
          </div>
        </div>
        <div class="inquiry_detail detail_content" v-if="manufacturing_method_count == 1">
            <div class="row" v-if="product_count == 1">
              <div class="info_tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="active" id="one-tab" data-bs-toggle="tab" data-bs-target="#one" type="button" role="tab" aria-controls="one" aria-selected="true">Product Details</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="two-tab" data-bs-toggle="tab" data-bs-target="#two" type="button" role="tab" aria-controls="two" aria-selected="false" v-on:click="dataTableLoad(0)">Attachment </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button id="three-tab" data-bs-toggle="tab" data-bs-target="#three" type="button" role="tab" aria-controls="three" aria-selected="false">Quotation </button>
                    </li>
                    <li v-if="rfqResp.status >= 12 && po_qa_details.length > 0" class="nav-item" role="presentation">
                        <button id="four-tab" data-bs-toggle="tab" data-bs-target="#four" type="button" role="tab" aria-controls="four" aria-selected="false">QA </button>
                    </li>
                </ul>
                <div class="tab-content detail_content" id="myTabContent">
                    <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
                      <div class="inquiry_detail detail_content">
                        
                          <div class="row">
                              <div class="col-md-3 contact_half_col">
                                  <div class="detail_col">
                                      <label>Manufacturing Method</label>
                                      <p>{{ manufacturing_methods[0].name }}</p>
                                  </div>
                              </div>
                              <div class="col-md-3 contact_half_col">
                                  <div class="detail_col">
                                      <label>Part Number</label>
                                      <p>{{ products[0].part_number }}</p>
                                  </div>
                              </div>
                              <div class="col-md-3 contact_half_col">
                                  <div class="detail_col">
                                      <label>Quantity</label>
                                      <p>{{ products[0].product_quantity }}</p>
                                  </div>
                              </div>
                              <div class="col-md-3 contact_half_col">
                                  <div class="detail_col">
                                      <label>Revision</label>
                                      <p>{{ products[0].revisions }}</p>
                                  </div>
                              </div>
                            
                              
                              <div class="col-md-12">
                                  <div class="detail_col">
                                      <label>Message/Notes</label>
                                      <div class="message-notes">
                                        <p class="font_400">{{ products[0].notes }}</p>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                    </div>
                    <div class="tab-pane fade" id="two" role="tabpanel" aria-labelledby="two-tab">
                      <div class="table_listing">
                          <table class="display attachment-table" width="100%">
                              <thead>
                                  <tr>
                                      <th>Filename.ext</th>
                                      <th>Part No.</th>
                                      <th>Document Type</th>
                                      <th>Date Uploaded</th>
                                      <th>Uploaded By</th>
                                      <th>View</th>
                                  </tr>
                              </thead>
                          </table>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="three" role="tabpanel" aria-labelledby="three-tab">
                      <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Price Per Quantity</h5>
                        <div class="child_table" v-if="rfqResp.status >= 3 && RFQProductList[0].product_price_per_quantiy !== '' " >
                         <table>
                            <thead>
                              <tr>
                                <th>Quantity</th>
                                <th>Price per quantity (USD)</th>
                                <th>Total Cost (USD)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(price, index) in RFQProductList[0].per_piece_cost_sell" :key="index">
                                <td v-if="index == 0">{{ 10 }} Piece / Delivery</td>
                                <td v-if="index == 1">{{ 100 }} Piece / Delivery</td>
                                <td v-if="index == 2">{{ 1000 }} Piece / Delivery</td>
                                <td v-if="index == 3">{{ 10000 }} Piece / Delivery</td>
                                <td>
                                  ${{ formatPrice(price) }}
                                </td>
                                <td>
                                  ${{ formatPrice(RFQProductList[0].total_sales[index]) }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Costs</h5>
                        <div v-if="rfqResp.status >= 3" class="row">
                            
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].tooling_cost != '' ">
                                <div class="detail_col">
                                  <label>Non-reoccurring engineering (NRE)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[0].nre_cost_sell) }}
                                  </p>
                                </div>
                            </div>

                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].tooling_cost != '' ">
                                <div class="detail_col">
                                  <label>Tooling cost (USD)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[0].tooling_cost) }}
                                  </p>
                                </div>
                            </div>

                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].additional_cost != '' ">
                                <div class="detail_col">
                                  <label>Additional cost (USD)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[0].additional_cost) }}
                                  </p>
                                </div>
                            </div>
                        </div>
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Delivery Milestones</h5>
                        <div v-if="rfqResp.status >= 3" class="row">
                            
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].sample_lead_time != '' ">
                                <div class="detail_col">
                                  <label>Sample Lead Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[0].sample_lead_time }} 
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].production_lead_time != '' ">
                                <div class="detail_col">
                                  <label>Production Lead Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[0].production_lead_time }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[0].finish_time != '' ">
                                <div class="detail_col">
                                  <label>Delivery Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[0].finish_time }}
                                  </p>
                                </div>
                            </div>
                        </div>
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Packaging Details</h5>
                        <div class="row" v-if="rfqResp.status >= 3">
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[0].packaging_type != '' ">
                                <div class="detail_col">
                                  <label>Packaging Type</label>
                                  <p>
                                      {{ RFQProductList[0].packaging_type }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[0].quantity_per_box != '' ">
                                <div class="detail_col">
                                  <label>Quantity per box</label>
                                  <p>
                                      {{ RFQProductList[0].quantity_per_box }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[0].package_width != '' ">
                                <div class="detail_col">
                                  <label>Size (LxWxH) </label>
                                  <p>
                                      {{ RFQProductList[0].package_length }}x{{ RFQProductList[0].package_width }}x{{ RFQProductList[0].package_height }} 
                                      <span class="info_caption">{{ RFQProductList[0].package_size_unit }}</span>
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[0].package_weight != '' ">
                                <div class="detail_col">
                                  <label>Weight</label>
                                  <p>
                                      {{ RFQProductList[0].package_weight }}<span class="info_caption">{{ RFQProductList[0].package_weight_unit }}</span>
                                  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="rfqResp.status >= 12 && po_qa_details.length > 0" class="tab-pane fade" id="four" role="tabpanel" aria-labelledby="four-tab">
                      <template v-for="(po_qa_detail,po_qa_index) in po_qa_details" :key="po_qa_index">
                        <div class="row" v-if="po_qa_detail.product_id == products[0].id">
                          <div class="col-md-4">
                              <div class="detail_col">
                                  <label>QA Ref No.</label>
                                  <p>{{po_qa_detail.qa_ref_no}}</p>
                              </div>
                          </div>
                          <div class="col-md-4">
                              <div class="detail_col">
                                  <label>Passed Items</label>
                                  <p>{{po_qa_detail.qa_pass_qty}}</p>
                              </div>
                          </div>
                          <div class="col-md-4">
                              <div class="detail_col">
                                  <label>Rejected Items</label>
                                  <p>{{po_qa_detail.qa_reject_qty}}</p>
                              </div>
                          </div>
                          <div class="col-md-12">
                                <div class="detail_col">
                                    <label>QA Remarks</label>
                                    <p v-html="po_qa_detail.qa_remarks"></p>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="po_qa_detail.show_qa_file_customer == 1">
                                <div class="detail_col">  
                                  <!-- <label>Attachment</label> -->
                                  <p><span class="material-icons-outlined blue_color">attachment</span>                               
                                      <a target="_blank" :href="po_qa_detail.qa_file" class="blue_color">Attachment&nbsp;</a>
                                  </p>
              
                                </div>
                            </div>
                        </div>
                      </template>
                    </div>
                </div>
              </div>

            </div>
                        
            <!-- Vertiacl Tabs Start Here -->
            <div class="vertical_tabs" v-if="product_count > 1"  ref="infoBox">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button v-for="(product,index) in products" :key="index" :class="index == 0 ? 'active' : '' " :id="'nav-'+index+'-tab'" data-bs-toggle="tab" :data-bs-target="'#nav-'+index" type="button" role="tab" :aria-controls="'nav-'+index" aria-selected="true" v-on:click="dataTableUnLoad( index, prod_index )">Part# {{ product.part_number }}</button>
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div v-for="(product,index) in products" :key="index" :class="index == 0 ? 'tab-pane fade show active': 'tab-pane fade' " :id="'nav-'+index" role="tabpanel" :aria-labelledby="'nav-'+index+'-tab'">
                  <div class="multi-product">
                    <div class="info_tabs">
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                              <button class="active" :id="'dtl-'+product.id+'-01'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-01'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-01'" aria-selected="true">Product Details</button>
                          </li>
                          <li class="nav-item" role="presentation">
                              <button :id="'dtl-'+product.id+'-02'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-02'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-02'" aria-selected="false" v-on:click="dataTableLoad(index, prod_index)">Attachment </button>
                          </li>
                          <li class="nav-item" role="presentation">
                              <button :id="'dtl-'+product.id+'-03'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-03'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-03'" aria-selected="false">Quotation </button>
                          </li>
                          <li v-if="rfqResp.status >= 12 && po_qa_details.length > 0" class="nav-item" role="presentation">
                              <button :id="'dtl-'+product.id+'-04'" data-bs-toggle="tab" :data-bs-target="'#detl-'+product.id+'-04'" type="button" role="tab" :aria-controls="'detl-'+product.id+'-04'" aria-selected="false">QA </button>
                          </li>
                      </ul>
                      <div class="tab-content detail_content" id="myTabContent">
                        <div class="tab-pane fade show active" :id="'detl-'+product.id+'-01'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-01'">
                          <div class="row">
                            <div class="col-md-4 contact_half_col">
                              <div class="detail_col">
                                <label>Manufacturing Method</label>
                                <p>{{ manufacturing_methods[0].name }}</p>
                              </div>
                            </div>
                            <div class="col-md-4 contact_half_col">
                              <div class="detail_col">
                                <label>Quantity</label>
                                <p>{{ product.product_quantity }}</p>
                              </div>
                            </div>
                            <div class="col-md-4 contact_half_col">
                              <div class="detail_col">
                                <label>Revision</label>
                                <p>{{ product.revisions }}</p>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="detail_col mb-0">
                                <label>Message/Notes</label>
                                <div class="message-notes">
                                  <p class="font_400">{{ product.notes }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane fade" :id="'detl-'+product.id+'-02'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-02'">
                          <div class="table_listing">    
                            <table class="display attachment-table" width="100%">
                                <thead>
                                    <tr>
                                        <th>Filename.ext</th>
                                        <th>Part No.</th>
                                        <th>Document Type</th>
                                        <th>Date Uploaded</th>
                                        <th>Uploaded By</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                            </table>
                          </div>
                        </div>
                        <div class="tab-pane fade" :id="'detl-'+product.id+'-03'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-03'">
                                                <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Price Per Quantity</h5>
                        <div class="child_table" v-if="rfqResp.status >= 3 && RFQProductList[index].product_price_per_quantiy !== '' " >
                         <table>
                            <thead>
                              <tr>
                                <th>Quantity</th>
                                <th>Price per quantity (USD)</th>
                                <th>Total Cost (USD)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(price, pIndex) in RFQProductList[index].per_piece_cost_sell" :key="pIndex">
                                <td v-if="pIndex == 0">{{ 10 }} Piece / Delivery</td>
                                <td v-if="pIndex == 1">{{ 100 }} Piece / Delivery</td>
                                <td v-if="pIndex == 2">{{ 1000 }} Piece / Delivery</td>
                                <td v-if="pIndex == 3">{{ 10000 }} Piece / Delivery</td>
                                <td>
                                  ${{ formatPrice(price) }}
                                </td>
                                <td>
                                  ${{ formatPrice(RFQProductList[index].total_sales[pIndex]) }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Costs</h5>
                        <div v-if="rfqResp.status >= 3" class="row">
                            
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].tooling_cost != '' ">
                                <div class="detail_col">
                                  <label>Non-reoccurring engineering (NRE)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[index].nre_cost_sell) }}
                                  </p>
                                </div>
                            </div>

                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].tooling_cost != '' ">
                                <div class="detail_col">
                                  <label>Tooling cost (USD)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[index].tooling_cost) }}
                                  </p>
                                </div>
                            </div>

                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].additional_cost != '' ">
                                <div class="detail_col">
                                  <label>Additional cost (USD)</label>
                                  <p>
                                      ${{ formatPrice(RFQProductList[index].additional_cost) }}
                                  </p>
                                </div>
                            </div>
                        </div>
                        <h5 v-if="rfqResp.status >= 3" class="font_700 my-4">Delivery Milestones</h5>
                        <div v-if="rfqResp.status >= 3" class="row">
                            
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].sample_lead_time != '' ">
                                <div class="detail_col">
                                  <label>Sample Lead Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[index].sample_lead_time }} 
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].production_lead_time != '' ">
                                <div class="detail_col">
                                  <label>Production Lead Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[index].production_lead_time }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-4 contact_half_col" v-if="RFQProductList[index].finish_time != '' ">
                                <div class="detail_col">
                                  <label>Delivery Time (in days)</label>
                                  <p>
                                      {{ RFQProductList[index].finish_time }}
                                  </p>
                                </div>
                            </div>
                        </div>
                        
                        <h5  v-if="rfqResp.status >= 3" class="font_700 my-4">Packaging Details</h5>
                        <div class="row" v-if="rfqResp.status >= 3">
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[index].packaging_type != '' ">
                                <div class="detail_col">
                                  <label>Packaging Type</label>
                                  <p>
                                      {{ RFQProductList[index].packaging_type }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[index].quantity_per_box != '' ">
                                <div class="detail_col">
                                  <label>Quantity per box</label>
                                  <p>
                                      {{ RFQProductList[index].quantity_per_box }}
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[index].package_width != '' ">
                                <div class="detail_col">
                                  <label>Size (LxWxH) </label>
                                  <p>
                                      {{ RFQProductList[index].package_length }}x{{ RFQProductList[index].package_width }}x{{ RFQProductList[index].package_height }} 
                                      <span class="info_caption">{{ RFQProductList[index].package_size_unit }}</span>
                                  </p>
                                </div>
                            </div>
                            <div class="col-md-3 contact_half_col" v-if="RFQProductList[index].package_weight != '' ">
                                <div class="detail_col">
                                  <label>Weight</label>
                                  <p>
                                      {{ RFQProductList[index].package_weight }}<span class="info_caption">{{ RFQProductList[index].package_weight_unit }}</span>
                                  </p>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div v-if="rfqResp.status >= 12 && po_qa_details.length > 0" class="tab-pane fade" :id="'detl-'+product.id+'-04'" role="tabpanel" :aria-labelledby="'dtl-'+product.id+'-04'">
                          <template v-for="(po_qa_detail,po_qa_index) in po_qa_details" :key="po_qa_index">
                            <div class="row" v-if="po_qa_detail.product_id == product.id">
                              <div class="col-md-4">
                                  <div class="detail_col">
                                      <label>QA Ref No.</label>
                                      <p>{{po_qa_detail.qa_ref_no}}</p>
                                  </div>
                              </div>
                              <div class="col-md-4">
                                  <div class="detail_col">
                                      <label>Passed Items</label>
                                      <p>{{po_qa_detail.qa_pass_qty}}</p>
                                  </div>
                              </div>
                              <div class="col-md-4">
                                  <div class="detail_col">
                                      <label>Rejected Items</label>
                                      <p>{{po_qa_detail.qa_reject_qty}}</p>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                    <div class="detail_col">
                                        <label>QA Remarks</label>
                                        <p v-html="po_qa_detail.qa_remarks"></p>
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="po_qa_detail.show_qa_file_customer == 1">
                                  <div class="detail_col">  
                                    <!-- <label>Attachment</label> -->
                                    <p><span class="material-icons-outlined blue_color">attachment</span>                               
                                        <a target="_blank" :href="po_qa_detail.qa_file" class="blue_color">Attachment&nbsp;</a>
                                    </p>
                
                                  </div>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div><!-- Vertiacl Tabs Ends Here -->
        </div>

        <br>
        <hr>
        <br>
        
        <h5 v-if="rfqResp && rfqResp.status >= 3" class="font_700">Shippping Type</h5>
        <div v-if="rfqResp && rfqResp.status >= 3">
          <p style="margin-bottom: 15px;margin-top: 15px;text-transform: capitalize;">{{rfqResp.shipping_type}}</p>
        </div>
        <h5 v-if="rfqResp && rfqResp.status >= 3" class="font_700">Tanfel Payment Terms</h5>
        <div class="msg-info-content" v-if="rfqResp && rfqResp.status >= 3">
          <div v-html="rfqResp.adm_payment_terms"></div>
        </div>
        <h5 v-if="rfqResp && rfqResp.status >= 3" class="font_700">Tanfel Comments</h5>
        <div class="msg-info-content" v-if="rfqResp && rfqResp.status >= 3" >
          <div v-html="rfqResp.message_customer"></div>
        </div>
        <br>
        <br>
        
        <div class="text-end">
          <div class="row">
            <div class="col-md-4">
                <div class="user-screen-star" v-if="rfq_status == 12">
                    <span style="color:black; margin-right:10px;">Rating</span>
                    <span  v-for="index in 5" :key="index"  class="material-icons-outlined">
                      <template v-if="index <= rating">star</template>
                      <template v-if="index > rating">star_outline</template>
                    </span>
                    <!-- <span  class="material-icons-outlined" v-if="index > rating">star_outline
                    </span> -->
                </div>

            </div>

            <div class="col-md-8">
              
              <a v-if="rfq_status == 12" class="btn btn-black ms-2" data-bs-toggle="modal" data-bs-target="#rating">Rating</a>
              <button v-if="rfq_status == 12" type="button" class="btn btn-gray ms-2" data-bs-toggle="modal" data-bs-target="#updateStatus">Update Status</button>
              <button @click="DeclineRFQ" v-if="rfq_status == 5" type="button" class="btn btn-secondary ms-2">Reject</button>
              <button @click="AcceptQuotation" v-if="rfq_status == 5" type="button" class="btn btn-primary ms-2">Accept</button>
              <a v-if="rfq_status == 7" class="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#upload_po">Create Purchase Order</a>
              <!-- <button @click="createQuotation" v-if="rfq_status == 7" type="button" class="btn btn-primary ms-2">Create Purchase Order</button> -->

            </div>
          </div>
        </div>
        <!-- <div v-if="rfq_status == 12"  class="rating display">
          
            <div class="quote_rating"> 
              <input :checked="rating == 5" type="radio" name="rating" value="5" id="5"><label for="5">☆</label> 
              <input :checked="rating == 4" type="radio" name="rating" value="4" id="4"><label for="4">☆</label> 
              <input :checked="rating == 3" type="radio" name="rating" value="3" id="3"><label for="3">☆</label> 
              <input :checked="rating == 2" type="radio" name="rating" value="2" id="2"><label for="2">☆</label> 
              <input :checked="rating == 1" type="radio" name="rating" value="1" id="1"><label for="1">☆</label> 
            </div>
            <div v-if="rating > 0" class="rating_value">{{ rating}}.0</div>

        </div> -->
       
        <h4 v-if="(rfq_status == 10) && support_message_count > 0" class="font_500 my-5">Messages</h4>
        <div v-if="(rfq_status == 10) && support_message_count > 0" class="chat_body">
          <ul>
            <li v-for="(message,index) in support_message" :key="index" :class="message.sender_id == currentUser.id ? 'sent': 'recive' ">
              <div v-if="message.sender_id != currentUser.id" style="display:flex">
                  <div class="chat_img">
                    <img src="../../../assets/images/img-5.png" alt="">
                  </div>
                  <div class="chat_message">
                    <h4>{{ message.sender.name }}</h4>
                     <h5>{{currentDateTime(message.created_at)}}</h5>
                    <div class="message_text">
                      <p  v-html="message.message"></p>
                      <small><a  v-if="message.attachment !== '' "  :href="message.attachment" target="_blank" class="blue_color"><span class="material-icons-outlined blue_color">attachment</span> Attachment</a></small>
                    </div>
                  </div>
              </div>
              <div v-if="message.sender_id == currentUser.id" style="display:flex">
                  <div class="chat_message">
                    <h4>{{ message.sender.name }}</h4>
                    <h5>{{currentDateTime(message.created_at)}}</h5>
                    <div class="message_text">
                      <p  v-html="message.message"></p>
                      <small><a v-if="message.attachment !== '' " :href="message.attachment" target="_blank" class="blue_color"><span class="material-icons-outlined blue_color">attachment</span> Attachment</a></small>
                    </div>
                  </div>
                  <div class="chat_img">
                    <img src="../../../assets/images/profile.png" alt="">
                  </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="text-end">
          <button v-if="(rfq_status == 10) && support_message_count > 0" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#adjustment">Reply</button>
        </div>
      </div>

        <!-- Request Adjustment Modal -->
        <div class="modal fade" id="adjustment" data-bs-backdrop="static" tabindex="-1" aria-labelledby="adjustmentLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="adjustmentLabel">Request Adjustment</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Send message to tanfel what adjustment you want to proceed further.</p>
                <div class="modal_content">
                  <form method="" action="">
                    <div class="form-group">
                      <label class="label">Message</label>
                      
                      <editor
                          api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                           @change="addMessage"
                          v-model="message"
                          :init="{
                            menubar: false,
                            plugins: 'lists link',
                            toolbar: 'bold italic | bullist'
                          }"
                        />
                    </div>
                    <div class="form-group">
                      <label class="label">Attachment</label>
                      <input @change="addFile" type="file" class="form-control" name="">
                    </div>
                    <div class="form-group">
                      <button @click="sendAdjustmentRequest" :disabled="required" type="button" class="btn btn-primary btn-block">Send Message</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Request Update Modal -->
        <div class="modal fade" id="updateStatus" data-bs-backdrop="static" tabindex="-1" aria-labelledby="adjustmentLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="adjustmentLabel">Request Update Status</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Ask Tanfel to update status</p>
                <div class="modal_content">
                  <form method="" action="">
                    <div class="form-group">
                      <label class="label">Message</label>
                      
                      <editor
                          api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                           @change="addMessage"
                          v-model="message"
                          :init="{
                            menubar: false,
                            plugins: 'lists link',
                            toolbar: 'bold italic | bullist'
                          }"
                        />
                    </div>
                    <div class="form-group">
                      <button @click="sendUpdateStatusRequest" :disabled="required" type="button" class="btn btn-primary btn-block">Send Message</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Upload Purchase Order Modal -->
        <div class="modal fade" id="upload_po" data-bs-backdrop="static" tabindex="-1" aria-labelledby="poLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="poLabel">Upload Purchase Order</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Please upload purchase order and send it to Tanfel</p>
                <div class="modal_content">
                  <form method="" action="">
                    <div class="form-group">
                      <label class="label">Upload Document <span class="required"></span></label>
                      <input accept=".doc,.docx,.pdf"  @change="addFilePO" type="file" class="form-control" name="">
                      <span class="info_caption"><strong>Supported formats:</strong> PDF, DOC, DOCx</span>
                    </div>
                    <div class="form-group">
                      <label class="label">Additional Details</label>
                      
                      <editor
                          api-key="ib23r73dw4tplnpttr0jwef67tx2w0e9m4x6mhdi4simy6uh"
                          v-model="messagePO"
                          @change="addMessagePO"
                          :init="{
                            menubar: false,
                            plugins: 'lists link',
                            toolbar: 'bold italic | bullist'
                          }"
                        />
                    </div>
                    <div class="form-group">
                      <button @click="createPO" type="button" :disabled="requiredPO" class="btn btn-primary btn-block">Upload</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Rate Quote Modal -->
        <div class="modal fade" id="rating" data-bs-backdrop="static" tabindex="-1" aria-labelledby="ratingLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="ratingLabel">Rate This PO</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                <div class="modal_content">
                  <form method="" action="">
                    <div class="form-group">
                      <div class="quote_rating"> 
                        <input :checked="rating == 5" @click="setRating(5)" type="radio" name="rating" value="5" id="5"><label for="5">☆</label> 
                        <input :checked="rating == 4" @click="setRating(4)" type="radio" name="rating" value="4" id="4"><label for="4">☆</label> 
                        <input :checked="rating == 3" @click="setRating(3)" type="radio" name="rating" value="3" id="3"><label for="3">☆</label> 
                        <input :checked="rating == 2" @click="setRating(2)" type="radio" name="rating" value="2" id="2"><label for="2">☆</label> 
                        <input :checked="rating == 1" @click="setRating(1)" type="radio" name="rating" value="1" id="1"><label for="1">☆</label> 
                      </div>
                      <div v-if="rating > 0" class="rating_value">{{ rating}}.0</div>
                    </div>
                    <div class="form-group">
                      <label>Comments</label>
                      <textarea rows="3" class="form-control" name="po_comments" v-model="po_comments"></textarea>
                    </div>
                    <div class="form-group">
                      <button @click="RatePO" type="button" class="btn btn-primary btn-block">Rate</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="sweet_overlay" v-if="showDeclineRFQ">
          <div class="sweet_modal">
            <div class="sweet_header">
              <span class="material-icons-outlined">info</span>
            </div>
            <div class="sweet_title">Reject</div>
            <div class="sweet_text">Are you sure you want to reject this Quotation?</div>
            <div class="sweet_footer">
            <button @click="cancelRFQConfirm" class="sweet_button sweet_button_cancel">Cancel</button>
            <button @click="declineRFQConfirm" class="sweet_button sweet_button_danger">Yes</button>
          </div>
        </div>
      </div>
      <div class="card_box message-inquery mt-4">
        <h2 class="page_title">Messages</h2>
        <div class="chat_body">
          <Messages :type="type" :token="accessToken" :loadItem="selecteItem" :needSend="true"></Messages>
        </div>
      </div>
    </main>
</template>
<script>
import $ from 'jquery';
import moment from 'moment';
import Editor from '@tinymce/tinymce-vue'
import Messages from "../../support/Messages.vue"
export default {
  name: "RFQDetails",
  components: {
    'editor': Editor,
    Messages
  },
  data(){
    return{
        moment: moment,
        inq_id: null,
        po_id: null,
        rfq_id: null,
        po_comments: null,
        manufacturing_methods: null,
        manufacturing_method_count: 0,
        support_message: null,
        support_message_count: 0,
        products: null,
        rfq_status: null,
        rfqResp: null,
        message: '',
        file: null,
        required: true,
        requiredPO: true,
        filePO: null,
        messagePO: '',
        rating: 0,
        product_count: 0,
        showDeclineRFQ: false,
        showLoader: false,
        API_URL: process.env.VUE_APP_API_URL,
        chat_userId: null,
        chat_user_type:null,
        chat_po: null,
        created_by:null,
        po_qa_details:[],
    };
  },
  computed: {
    currentUser() {
        return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
   watch: { 
      
    chat_userId () { 

      this.selecteItem = {
        "module_id": this.chat_po,
        "module_name":"po",
        "user_id" :  this.chat_userId,
      }
      this.type = this.currentUser.user_type;
      this.accessToken = this.currentUser.accessToken;

    },
    created_by() {
      if ( this.chat_user_type != "Admin" ) {
        this.chat_userId = this.created_by;
      } 
    }

  },
  mounted() {
    // var height = $('.vertical_tabs').height($('.detail_content').height() - 100);
    
      this.po_id=this.$route.params.id;
      //  this.getChatUser();
      this.geInquiry();
       if (!this.currentUser) {
            this.$router.push('/login');
       }
  },
  methods: {
    addMessage(){
      this.required = false;
    },
    currentDateTime(time) {
      return moment(time).fromNow();
    },
    addFile(event){
        this.file = event.target.files[0];
    },
    addMessagePO(event){
      this.messagePO = event.target.value;
    },
    addFilePO(event){
        this.filePO = event.target.files[0];
        this.requiredPO = false;
    },
    back_rfqs() {
        this.$router.push('/quotations');
    },  
    logOut() {
        this.$store.dispatch('auth/logout');
        this.$router.push('/login');
    },

     /* Method to get the Received ID for Chart */
    getChatUser () {


      let module_id = this.po_id;
      let module_name = "po";
     
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

      var formdata = new FormData();
      formdata.append( "module_id", module_id );
      formdata.append( "module_name", module_name );

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.API_URL + "getChatUserId", requestOptions)
      .then(response => response.text())
      .then(result => { 

        var response = JSON.parse(result);
        console.log("respo", response);
        this.chat_userId = response.data.chat_user_id;

      })
      .catch(error => console.log('error', error));

    },

    declineRFQConfirm(){
        var store = this.$store;
        var route = this.$router;
        this.showDeclineRFQ = false;
        this.showLoader = true; 

        var formdata = new FormData();
        formdata.append("rfq_id", this.rfq_id);
        formdata.append("api_token", this.currentUser.accessToken);

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.API_URL +"customer/quotation-reject", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Quotation Rejected Successfylly.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.push('/quotations');
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    createPO(){
        var store = this.$store;
        var route = this.$router;
        $('#upload_po').hide();
        $('.modal-backdrop').hide();
        this.showLoader = true; 
        var formdata = new FormData();
        formdata.append("rfq_id", this.rfq_id);
        formdata.append("inquiry_id", this.rfqResp.inquiry_id);
        formdata.append("customer_id", this.rfqResp.customer_id);
        formdata.append("api_token", this.currentUser.accessToken);
        formdata.append("po_document", this.filePO);
        formdata.append("cust_message", this.messagePO);

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.API_URL + "create-purchase-order", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Request sent to admin successfully.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.push('/quotations');
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    sendUpdateStatusRequest(){
        var store = this.$store;
        var route = this.$router;
        $('#updateStatus').hide();
        $('.modal-backdrop').hide();
        this.showLoader = true; 
        var formdata = new FormData();
        formdata.append("rfq_id", this.rfq_id);
        formdata.append("po_id", this.po_id);
        formdata.append("api_token", this.currentUser.accessToken);
        formdata.append("attachment", this.file);
        formdata.append("message", this.message);
        formdata.append("status", this.rfq_status);

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };
        fetch(this.API_URL + "customer/status-update-po", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Request sent to admin successfully.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.push('/purchase-order');
                // this.support_message = response.data.support_message;
                // this.support_message_count = this.support_message.length;
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    cancelRFQConfirm(){
        this.showDeclineRFQ = false;
    },
    setRating(rating){
        this.rating = rating;
    },
    RatePO(){
        var store = this.$store;
        var route = this.$router;
        this.showDeclineRFQ = false;
        this.showLoader = true; 
        $('#rating').hide();
        $('.modal-backdrop').hide();
        var formdata = new FormData();
        formdata.append("po_id", this.po_id);
        formdata.append("rating", this.rating);
        //formdata.append("comments", this.po_comments);
        formdata.append("comments", $('[name=po_comments]').val());
        formdata.append("api_token", this.currentUser.accessToken);

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.API_URL + "customer/po-rating", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with po/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Thanks for giving rate to this PO.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.push('/purchase-order');
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    AcceptQuotation(){
        var store = this.$store;
        var route = this.$router;
        this.showDeclineRFQ = false;
        this.showLoader = true; 

        var formdata = new FormData();
        formdata.append("rfq_id", this.rfq_id);
        formdata.append("api_token", this.currentUser.accessToken);

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.API_URL + "customer/accept-quotation", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Quotation Accepted Successfylly.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.push('/quotations');
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    DeclineRFQ(){
        this.showDeclineRFQ = true;
    },
    createQuotation(){
        this.$router.push('/create-quotation/'+this.rfq_id);
    },
    formatPrice(value) {
        //let val = (value/1).toFixed(2).replace(',', '.')
        //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    sendAdjustmentRequest(){
        var store = this.$store;
        var route = this.$router;
        $('#adjustment').hide();
        $('.modal-backdrop').hide();
        this.showLoader = true; 
        var formdata = new FormData();
        formdata.append("rfq_id", this.rfq_id);
        formdata.append("po_id", this.po_id);
        formdata.append("api_token", this.currentUser.accessToken);
        formdata.append("attachment", this.file);
        formdata.append("message", this.message);
        formdata.append("status", this.rfq_status);
        formdata.append("module_name", 'adjust-po');

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(this.API_URL + "customer/adjust-po", requestOptions)
          .then(response => response.text())
          .then(result =>  {
              console.log(result);
               var response = JSON.parse(result);
              if(response.message == 'Token not found.' || response.message == 'something went wrong with inquiry/token information.'){
                  this.$toast.show("Your token expired, please login again.", {
                      type: "info",
                      dismissible: true,
                      position: 'top',  
                      duration:3500,
                      pauseOnHover: true,  
                    // all of other options may go here
                  });
                this.showLoader = false; 
                store.dispatch('auth/logout');
                route.push('/login');
              }else{
                this.$toast.show("Request sent to admin successfully.", {
                    type: "success",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                // all of other options may go here
                });
                this.showLoader = false; 
                route.go();
                // this.support_message = response.data.support_message;
                // this.support_message_count = this.support_message.length;
              }
          })
          .catch(error => {
              this.$toast.show("Something went wrong!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                  // all of other options may go here
                });
                console.log(error);
                this.showLoader = false; 
                this.showDeclineRFQ = false;
          });
    },
    geInquiry() {
     
      // let height = this.$refs.infoBox.height;
    
        var store = this.$store;
        var route = this.$router;
        this.showLoader = true; 
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer "+this.currentUser.accessToken);
        var formdata = new FormData();
        formdata.append("po_id", this.po_id);
        formdata.append("api_token", this.currentUser.accessToken);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(this.API_URL + "customer/po-detail", requestOptions)
          .then(response => response.text())
          .then(result => { 
              var response = JSON.parse(result);
              if(response.message == 'Token not found.'){
                  this.showLoader = false; 
                  store.dispatch('auth/logout');
                  route.push('/login');
              }else{
                this.manufacturing_methods = response.data.Product_Insterests;
                this.manufacturing_method_count = this.manufacturing_methods.length;
                this.products = response.data.products;
                this.RFQProductList = response.data.RFQProductList;
                this.rfqResp = response.data.rfqResp;
                this.product_count = this.products.length;
                this.support_message = response.data.support_message;
                this.support_message_count = this.support_message.length;
                this.showLoader = false; 
                this.rfq_id = response.data.rfq_id;
                this.inq_id = response.data.inq_id;
                this.rfq_status = response.data.rfq_status;
                this.chat_userId = response.data.rfqResp.created_by;
                this.chat_po = response.data.POResp.tracking_id;
                this.po_qa_details = response.data.PoDetails;
                this.rating = response.data.POResp.rating;
                this.po_comments = response.data.POResp.rating_cmnts;

                this.getChatUser();

                console.log( "Chat PO:", this.chat_po );
                console.log( "Date:", response.data );
                console.log( "{PoDetails}:", this.po_qa_details );
              }
          })
          .catch(error => console.log('error', error));
    },
     dataTableUnLoad( prodIndex, partIndex ){
       $('.attachment-table').DataTable().destroy();
       this.tableDraw = false; 
       this.dataTableLoad( prodIndex, partIndex )
    },
    dataTableLoad( prodIndex, partIndex ) {
      if(this.tableDraw){
        return;
      }

      let DocArray = [];
      let OrginalProduct = this.products[prodIndex];

      if ( Array.isArray (OrginalProduct ) ) {
        
        if ( OrginalProduct.length > 1 ) {
          OrginalProduct = OrginalProduct[ partIndex ]
        } else {
          OrginalProduct = OrginalProduct[0]
        }
      }

      let docs = OrginalProduct.upload_supporting_doc;
      let images = OrginalProduct.upload_product_images;
      let part_no = OrginalProduct.part_number;
      let updated_at = OrginalProduct.updated_at;

      docs.forEach((value, index) => {
          let myObj = {
            document: "Document-"+index,
            part_number: part_no,
            doc_type: "supporting/pdf",
            date_upload: updated_at,
            upload_by: "User",
            action: `<a href='${value} ' target='_blank'><span class='material-icons-outlined' data-toggle='tooltip' title='View'>visibility</span></a>`,
          }
          DocArray.push(myObj)
      });

      images.forEach((value, index) => {
          let myObj = {
            document: "Image-"+index,
            part_number: part_no,
            doc_type: "drawing/image",
            date_upload: updated_at,
            upload_by: "User",
            action: `<a href='${value} ' target='_blank'><span class='material-icons-outlined' data-toggle='tooltip' title='View'>visibility</span></a>`,
          }
          DocArray.push(myObj)
      });

       $('.attachment-table').DataTable({
        sDom: 'rtilfp',
        bFilter: false,
        data: DocArray,
          columns: [
              { data: 'document'},
              { data: 'part_number' },
              { data: 'doc_type' },
              { data: 'date_upload' },
              { data: 'upload_by' },
              { data: 'action' },
          ],
      });

      this.tableDraw = true;
    }
  },
};
</script>